import React from "react";
import loading from "../../assets/loading.gif";

const Loading = () => {
    return <img src={loading} alt="Loading..." />;
};

export default Loading;
